<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:59:24
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:38:34
-->
<template>
	<!-- 选择合作达人 -->
	<div>
		<el-drawer title="选择合作达人" size="724px" :append-to-body="true" :visible.sync="visible" @closed="reset" :wrapperClosable="false">
			<p class="mb-16">
				<el-alert :closable="false" show-icon class="el-alert" title="商团协作样品订单必须选择sku，否则无法协同成功" type="warning"></el-alert>
			</p>

			<!-- 搜索框部分 -->
			<div class="pos-rela flex-row-align-center">
				<!-- <el-input placeholder="请输入达人昵称" v-model="anchor_account"></el-input> -->
				<SelectTag
					ref="selectTag"
					:type="1"
					:placeholder="'请选择达人标签'"
					style="width: 200px"
					:collapseTags="true"
					:multiple="true"
					v-model="tag_id"
				></SelectTag>
				<div class="drContactsCel flex-1 ml-12">
					<el-select class="select-type" v-model="selectType" @change="onChange">
						<el-option v-for="(item, index) in selectParams" :value="item.value" :label="item.label" :key="index"></el-option>
					</el-select>
					<div class="line"></div>
					<el-input style="width: 296px" class="select-search" placeholder="请输入" v-model.trim="anchor_account"></el-input>
				</div>
				<el-button class="searchBtn" style="height: 34px" @click="getDrList()">搜索</el-button>
			</div>
			<!-- 新增达人提示按钮部分 -->
			<div class="mt-12 flex-just-end flex-row">
				<el-button @click="skipCRM" type="text" class="yx-pingfang-semibold font-h5-regular">没找到?去达人CRM添加</el-button>
			</div>
			<!-- 列表部分 -->
			<div class="mt-12 mb-40" v-loading="loading">
				<div class="anthor-table">
					<div class="anthor-table-header">
						<div class="anthor-table-tr">
							<div class="anthor-table-td" style="width: 30px">
								<el-checkbox label="" v-model="checkAll" :indeterminate="indeterminate"></el-checkbox>
							</div>
							<div class="anthor-table-td" style="width: 243px">达人昵称</div>
							<div class="anthor-table-td" style="width: 241px">{{ platformId | formatPlatformName('unify') }}</div>
							<div class="anthor-table-td" style="width: 147px">粉丝数</div>
						</div>
					</div>
					<div
						class="anthor-table-body"
						v-scroll-lazy-load="{
							loadData,
							distance: 300,
							delay: 1000,
							callback: fn => this.$once('hook:beforeDestroy', () => fn()),
						}"
					>
						<el-checkbox-group v-model="selectArr">
							<div class="anthor-table-tr" v-for="row in drList" :key="row.id">
								<div class="anthor-table-td" style="width: 30px">
									<el-checkbox
										:label="row.id"
										:disabled="disabledList.some(item => item.id === row.id) || ($isSp(row.platform_id) && row.check_status != 2)"
									></el-checkbox>
								</div>
								<div class="anthor-table-td" style="width: 241px">{{ row.anchor_name }}</div>
								<div class="anthor-table-td flex-row" style="width: 243px">
									<SpVerify
										:anchoId="row.id"
										:anchorUid="row.anchor_uid"
										:platformId="row.platform_id"
										:type="row.check_status"
										@refresh="spVerifyRefresh"
									>
										<span class="mr-4">{{ anchorAccount(row) }}</span>
									</SpVerify>
								</div>
								<div class="anthor-table-td" style="width: 147px">{{ row.fans_num }}</div>
							</div>
						</el-checkbox-group>

						<p class="pt-20 pb-20 font-h4-regular yx-color-text-regular flex-center">
							<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
							<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
						</p>
					</div>
				</div>
			</div>
			<!-- 底部按钮部分 -->
			<div class="bott">
				<span class="pl-24 font-h5-regular yx-color-text-primary">
					已选
					<span class="yx-color-primary">{{ selectedNum }}</span>
					个，最多可选
					<span class="yx-color-primary">{{ limit }}</span>
					个
				</span>
				<div>
					<el-button @click="handleClose">取 消</el-button>
					<el-button type="primary" @click="submit" :loading="btnloading" :disabled="btnIsAbled">确认添加</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { selectListPage } from '@/api/shopManage';
import SelectTag from '@/components/business/tagDialog/selectTag.vue';
export default {
	name: 'ChooseCooAnthorDrawer',
	components: { SelectTag },
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_ALL.value,
		},
		selectable: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
	},
	data() {
		return {
			visible: false,
			tag_id: '', //Select框绑定的达人标签的值
			anchor_account: '', //input框绑定的达人名称的值
			options: { selectable: true },
			selectArr: [], // 选择的达人id列表
			selectObjArr: [], // 选择的达人对象列表
			disabledList: [], //已经禁用的列表
			drList: [], //所有达人的列表
			limit: 20,
			loading: true,
			btnloading: false,
			btnIsAbled: true,

			params: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '加载更多',
				status: 'pending',
			},
			checkAll: false,
			indeterminate: false,
			selectType: 'anchor_name',
		};
	},
	watch: {
		anchor_account(val) {
			if (!val) this.getDrList();
		},
		selectedNum(val) {
			this.btnIsAbled = val > 20 || this.selectArr.length == 0;
		},
		checkAll(val) {
			this.selectArr = val ? this.notSelectedDrList.map(item => item.id) : [];
		},
		list: {
			handler(val) {
				this.indeterminate = !!(val.selectArr.length && val.drList.length && val.selectArr.length !== val.drList.length);
			},
			deep: true,
		},
		selectArr(val, pre) {
			// 新增
			if (val.length > pre.length) {
				// 找出新增的达人ID
				const addedIdArr = val.filter(item => !pre.includes(item));
				// 匹配当前的达人列表找出新增的达人对象
				const addedObjArr = this.drList.filter(item => addedIdArr.includes(item.id));
				// 添加到选中的对象列表中
				this.selectObjArr.push(...addedObjArr);
			} else {
				// 找出新增的达人ID
				const deledIdArr = pre.filter(item => !val.includes(item));
				// 匹配当前的达人列表找出新增的达人对象
				deledIdArr.forEach(element => {
					// 匹配找出删除的达人对象
					const ind = this.selectObjArr.findIndex(item => element === item.id);
					// 在选中的对象列表中删除达人
					this.selectObjArr.splice(ind, 1);
				});
			}
		},
	},
	computed: {
		selectedNum() {
			return this.selectArr.length + this.disabledList.length;
		},
		list() {
			return {
				drList: this.drList,
				selectArr: this.selectArr,
			};
		},
		notSelectedDrList() {
			return this.drList.filter(item => this.disabledList.every(disabledItem => disabledItem.id !== item.id));
		},
		placeholderText() {
			let temPF = new Map([
				[+dataMap.PLATFORM_DY.value, '抖音号'],
				[+dataMap.PLATFORM_KS.value, '快手号'],
				[+dataMap.PLATFORM_SP.value, '视频号'],
				[+dataMap.PLATFORM_XHS.value, '小红书号'],
			]);
			return temPF.get(this.platformId);
		},
		selectParams({ placeholderText }) {
			return [
				{
					label: '达人昵称',
					value: 'anchor_name',
				},
				{
					label: placeholderText,
					value: 'anchor_account',
				},
			];
		},
	},
	methods: {
		spVerifyRefresh(res) {
			const index = this.drList.findIndex(item => item.id == res.anchor_id);
			this.$set(this.drList, index, {
				...this.drList[index],
				anchor_uid: res.anchor_uid,
				check_status: 2,
			});
		},
		anchorAccount(item) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: item.anchor_account,
				[dataMap.PLATFORM_KS.value]: item.anchor_account,
				[dataMap.PLATFORM_SP.value]: item.anchor_uid,
				[dataMap.PLATFORM_XHS.value]: item.anchor_account,
			};
			return temPF[item.platform_id];
		},
		show(list) {
			if (list.length) {
				this.disabledList = list;
			}
			this.getDrList();
			this.visible = true;
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.params.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getDrList(true);
		},
		//刷新列表
		async getDrList(loadMore) {
			if (!loadMore) {
				this.params.page_index = 1;
				this.loading = true;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			const data = await selectListPage({
				...this.params,
				[this.selectType]: this.anchor_account,
				platform_id: this.platformId,
				tag_id: this.tag_id,
			});
			// 加载更多并且还有下一页才会加载
			if (loadMore) {
				this.drList = this.drList.concat(data.list);
			} else {
				this.drList = data.list;
			}
			this.loadmore = !data.page.page_has
				? {
						text: '已经到底了',
						status: 'nomore',
				  }
				: {
						text: '加载更多',
						status: 'pending',
				  };
			if (!loadMore) {
				this.loading = false;
			}
		},
		// 保存提交
		submit() {
			const { selectObjArr } = this;
			// 转换为达人对象返回父组件
			this.$emit('getDrList', selectObjArr);
			this.$message.success('添加成功');
			this.reset();
			this.handleClose();
		},
		// 关闭
		handleClose() {
			this.visible = false;
			this.params.page_index = 1;
		},
		reset() {
			this.$refs.selectTag.reset();
			this.anchor_account = '';
			this.selectedDrList = [];
			this.disabledList = [];
			this.params.page_index = 1;
			this.checkAll = false;
			this.selectArr = [];
			this.selectObjArr = [];
			this.indeterminate = false;
			this.drList = [];
			this.tag_id = '';
			this.selectType = 'anchor_name';
		},
		// 跳转CRM
		skipCRM() {
			const handLink = this.$router.resolve({
				path: '/talentCRM',
				query: { platformId: this.platformId },
			});
			window.open(handLink.href, '_blank');
		},
		onChange() {
			this.anchor_account = '';
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 24px 24px 70px !important;
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @border-color-lighter;
	}
}
.searchBtn {
	width: 72px;
	background-color: @color-primary;
	color: #ffffff;
	font-size: 13px;
	border-radius: 2px;
	position: absolute;
	right: 0;
	top: 0;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
.anthor-table {
	display: table;
	&-header {
		color: @color-text-secondary !important;
		font-size: 12px !important;
		font-family: PingFangSC-Regular;
	}
	&-body {
		height: calc(100vh - 320px);
		overflow-y: auto;
		.nomore {
			&::before {
				content: '- ';
			}
			&::after {
				content: ' -';
			}
		}
	}
	&-tr {
		display: table-row;
	}
	&-td {
		display: table-cell;
		font-size: 12px;
		padding: 12px 0;
		border-bottom: 1px solid @border-color-base;
	}
}
&::-webkit-scrollbar {
	width: 6px;
}

&::-webkit-scrollbar-thumb {
	height: 26px;
	border-radius: 3px;
	background-color: @color-text-placeholder;
}
/deep/.el-checkbox__label {
	display: none;
}
.drContactsCel {
	position: relative;
	border-radius: 4px;
	background: @color-gy1;
	border: 1px solid @color-gy4;
}
.drContactsCel:hover {
	border-color: @color-primary;
}
.line {
	position: absolute;
	width: 1px;
	height: 32px;
	left: 100px;
	top: 0px;
	background: @color-gy4;
	z-index: 2;
}
.select-type {
	width: 100px;
	/deep/ .el-input__inner {
		border-radius: 4px 0px 0px 4px;
		border: none;
	}
}
.select-search {
	/deep/ .el-input__inner {
		border-radius: 0px 4px 4px 0px;
		border: none;
	}
}
</style>
